document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('collection-quick-view-modal');
  if (!modal) return;

  var modalImage = modal.querySelector('[data-cqv-image]');
  var modalTitle = modal.querySelector('[data-cqv-title]');
  var modalPrice = modal.querySelector('[data-cqv-price]');
  var modalDescription = modal.querySelector('[data-cqv-description]');
  var modalOptions = modal.querySelector('[data-cqv-options]');
  var modalAddBtn = modal.querySelector('[data-cqv-add-to-cart]');
  var modalStatus = modal.querySelector('[data-cqv-status]');
  var closeBtn = modal.querySelector('[data-cqv-close]');
  var prevBtn = modal.querySelector('[data-cqv-prev]');
  var nextBtn = modal.querySelector('[data-cqv-next]');
  var quantityInput = modal.querySelector('[data-cqv-quantity]');
  var quantityDecreaseBtn = modal.querySelector('[data-cqv-quantity-decrease]');
  var quantityIncreaseBtn = modal.querySelector('[data-cqv-quantity-increase]');

  var currentProduct = null;
  var selectedOptions = [];
  var currentImageIndex = 0;

  function showImage(index) {
    if (!currentProduct || !currentProduct.images.length) return;
    var total = currentProduct.images.length;
    currentImageIndex = ((index % total) + total) % total;
    modalImage.src = currentProduct.images[currentImageIndex];
  }

  function updateGalleryNav() {
    var hasMultiple = currentProduct && currentProduct.images.length > 1;
    if (prevBtn) prevBtn.hidden = !hasMultiple;
    if (nextBtn) nextBtn.hidden = !hasMultiple;
  }

  function findMatchingVariant() {
    if (!currentProduct) return null;
    return currentProduct.variants.find(function (variant) {
      return variant.options.every(function (val, idx) {
        return val === selectedOptions[idx];
      });
    });
  }

  function renderOptions() {
    modalOptions.innerHTML = '';
    if (!currentProduct.options || currentProduct.options.length < 1) return;
    var variants = currentProduct.variants || [];
    if (variants.length === 1 && variants[0].title === 'Default Title') return;

    currentProduct.options.forEach(function (option, index) {
      var wrapper = document.createElement('div');
      var label = document.createElement('label');
      label.textContent = option.name;
      var select = document.createElement('select');
      select.setAttribute('data-option-index', index);

      option.values.forEach(function (value) {
        var opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;
        select.appendChild(opt);
      });

      select.addEventListener('change', function () {
        selectedOptions[index] = select.value;
        updateForVariant();
      });

      wrapper.appendChild(label);
      wrapper.appendChild(select);
      modalOptions.appendChild(wrapper);
    });
  }

  function updateForVariant() {
    var variant = findMatchingVariant();
    if (!variant) return;
    modalPrice.textContent = variant.price;
    modalAddBtn.disabled = !variant.available;
    modalAddBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    modalStatus.textContent = '';
    modalAddBtn.setAttribute('data-variant-id', variant.id);

    var variantImageIndex = currentProduct.images.indexOf(variant.image);
    showImage(variantImageIndex > -1 ? variantImageIndex : 0);
  }

  function openModalWithData(productData) {
    currentProduct = productData;
    selectedOptions = currentProduct.variants[0] ? currentProduct.variants[0].options.slice() : [];

    modalTitle.textContent = currentProduct.title;
    modalDescription.textContent = currentProduct.description;
    modalStatus.textContent = '';
    if (quantityInput) quantityInput.value = 1;
    updateGalleryNav();

    renderOptions();

    var selects = modalOptions.querySelectorAll('select');
    selects.forEach(function (select, idx) {
      if (selectedOptions[idx]) select.value = selectedOptions[idx];
    });

    updateForVariant();

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.product-card__link');
    if (!link) return;

    var card = link.closest('product-card');
    if (!card) return;

    var script = card.querySelector('script[data-quick-view-json]');
    if (!script) return;

    var productData;
    try {
      productData = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    event.preventDefault();
    openModalWithData(productData);
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      showImage(currentImageIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      showImage(currentImageIndex + 1);
    });
  }

  if (quantityDecreaseBtn) {
    quantityDecreaseBtn.addEventListener('click', function () {
      var value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) - 1);
      quantityInput.value = value;
    });
  }

  if (quantityIncreaseBtn) {
    quantityIncreaseBtn.addEventListener('click', function () {
      var value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) + 1);
      quantityInput.value = value;
    });
  }

  if (quantityInput) {
    quantityInput.addEventListener('change', function () {
      var value = Math.max(1, parseInt(quantityInput.value, 10) || 1);
      quantityInput.value = value;
    });
  }

  closeBtn.addEventListener('click', function () {
    modal.close ? modal.close() : modal.removeAttribute('open');
  });

  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      modal.close ? modal.close() : modal.removeAttribute('open');
    }
  });

  modalAddBtn.addEventListener('click', function () {
    var variantId = modalAddBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    var quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;

    modalAddBtn.disabled = true;
    modalStatus.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        modalStatus.innerHTML = 'Added to cart! <a href="/cart">View cart</a>';
        modalAddBtn.disabled = false;
      })
      .catch(function () {
        modalStatus.textContent = 'Something went wrong. Please try again.';
        modalAddBtn.disabled = false;
      });
  });
});